<div class="step-container registration-membership-options">
  <ng-container *ngIf="children && membershipOptions">
    <h5 class="registration-membership-option-title">{{ 'fgbcl.registration.membership.options.title' | translate }}</h5>
    <p
      class="membership-option-instructions"
      [innerHtml]="'registration.membership.options.instruction' | translate | markdownTranslate"
    >
      {{
        'registration.membership.options.instruction'
          | translate: { fgbdefault: 'Please choose your membership option for each kid in the list below:' }
      }}
    </p>
    <div class="membership-layout">
      @if (showMembershipOptions) {
        <div class="membership-options">
          <div class="membership-option" *ngFor="let membershipOption of membershipOptions">
            <div class="img-container">
              <img alt="" src="{{ membershipOption.ImageUrl | contentImage: '3' }}" class="membership-option-image" />
            </div>
            <div class="membership-detail">
              <h5>{{ membershipOption.DisplayName }}</h5>
              <span class="price-value">
                <ng-container *ngIf="membershipOption.MerchantPrice > 0; else freeMembership">
                  {{ membershipOption.MerchantPrice / 100 | FortressCurrencyPipe }}
                </ng-container>
                <ng-template #freeMembership>
                  {{ 'registration.membership.option.free.membership' | translate }}
                </ng-template>
              </span>
            </div>
            <div class="membership-benefits">
              <label>{{ 'registration.membership.options.membership.includes.label' | translate }}</label>
              <p [innerHtml]="membershipOption.Description | markdownTranslate"></p>
            </div>
            <button class="btn select-membership-button" (click)="selectMembership(membershipOption.MembershipOptionId)">
              {{ 'registration.membership.option.select.membership.button' | translate }}
            </button>
          </div>
        </div>
      } @else {
        <div class="child-membership-container">
          <form [formGroup]="childrenForm">
            <div formArrayName="children">
              <div class="child-membership-item" *ngFor="let child of childrenForm.get('children')?.controls; let i = index">
                <div [formGroupName]="i">
                  <h5>{{ 'registration.membership.options.child.title' | translate: { fgbdefault: 'Child' } }} {{ i + 1 }}</h5>
                  <div class="form-group">
                    <div class="child-info">
                      <label class="mb-0">{{ child.value.Firstname + ' ' + child.value.Lastname }}</label>
                      <span class="mb-0">{{ child.value.DateOfBirth | date: 'mediumDate' : 'UTC' }}</span>
                    </div>
                    <div class="child-membership-option">
                      <button
                        class="btn membership-button"
                        (click)="showMembershipOption(child)"
                        *ngIf="!child.value.MembershipOptionId"
                      >
                        {{ 'registration.membership.option.select.membership.button' | translate }}
                      </button>
                    </div>
                  </div>
                  <ng-container *ngIf="child.value.MembershipOptionId">
                    <ng-container
                      *ngTemplateOutlet="
                        selectedMembership;
                        context: { $implicit: child.value.MembershipOptionId | membershipOption: membershipOptions, child: child }
                      "
                    ></ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </form>
        </div>
      }
      <div class="error-message" *ngIf="childrenForm.invalid && childrenForm.touched">
        {{
          'registration.membership.option.form.invalid'
            | translate: { fgbdefault: 'Please select membership option for each child' }
        }}
      </div>
      <!-- Server Side Errors -->
      <fgbcl-errors></fgbcl-errors>
    </div>
  </ng-container>
  <div class="registration-navigataion-button-container" *ngIf="!showMembershipOptions">
    <fgbcl-registration-navigation
      (nextButtonClicked)="submitStep()"
      [stepType]="stepType"
      [hideNextBtn]="!hasSelectedMembership"
    ></fgbcl-registration-navigation>
  </div>
</div>

<ng-template #selectedMembership let-membership let-child="child">
  <div class="selected-membership">
    <div class="selected-membership-details">
      <img alt="" src="{{ membership.ImageUrl | contentImage: '1' }}" class="membership-logo" />
      <div class="membership-details">
        <label class="membership-product-name">{{ membership.DisplayName }}</label>
        <div class="price">
          <label>{{ 'registration.membership.options.price.label' | translate }}</label>
          <span class="price-value">
            <ng-container *ngIf="membership.MerchantPrice > 0; else freeMembership">
              {{ membership.MerchantPrice / 100 | FortressCurrencyPipe }}
            </ng-container>
            <ng-template #freeMembership>
              {{ 'registration.membership.option.free.membership' | translate }}
            </ng-template>
          </span>
        </div>
      </div>
    </div>
    <button class="btn change-membership-btn" (click)="showMembershipOption(child)">
      {{ 'registration.membership.options.change.membership' | translate }}
    </button>
  </div>
</ng-template>
